import React, { useEffect, useState } from "react";
import { getMetaData, tourBookingReport } from "../../../api/admin/tourApi";
import * as XLSX from "xlsx";
import SendButton from "../../../components/admin/usable/SendButton";
import CancelButton from "../../../components/admin/usable/CancelButton";

const TourBookingReport = () => {
  const [Data, setData] = useState([]);
  const [Tours, setTours] = useState([]);
  const [Customers, setCustomers] = useState([]);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [SelectedTour, setSelectedTour] = useState("");
  const [SelectedCustomer, setSelectedCustomer] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  useEffect(() => {
    tourBookingReport(
      setData,
      StartDate,
      EndDate,
      SelectedTour,
      SelectedCustomer,
      setIsLoading,
    );
  }, [StartDate, EndDate, SelectedTour, SelectedCustomer]);
  useEffect(() => {
    getMetaData(setTours, setCustomers, setIsLoading);
  }, []);
  const totalSummary = Data.reduce(
    (acc, item) => {
      const actual = item.actualPrice || 0;
      const discount = item.discount || 0;

      const discountedAmount =
        discount > 0 ? actual - (actual * discount) / 100 : 0;

      acc.totalAmount += item.totalAmount || 0;
      acc.actualPrice += actual;
      acc.discountedAmount += discountedAmount;

      return acc;
    },
    {
      totalAmount: 0,
      actualPrice: 0,
      discountedAmount: 0,
    },
  );
  const handleHotelChange = (e) => {
    const tourId = e.target.value;
    setSelectedTour(tourId);
  };
  const handleCustomerChange = (e) => {
    const userId = e.target.value;
    setSelectedCustomer(userId);
  };
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      Data.map((item, index) => ({
        ID: index + 1,
        Invoice: item.invoiceId,
        Transaction: item.transactionId,
        Hotel: item.hotelName,
        Customer: item.fullName,
        actualPrice: item.actualPrice,
        discount: item.discount,
        TotalAmount: item.totalAmount,
        startDate: item.startDate,
        endDate: item.endDate,
        Status: item.paymentStatus,
        Date: item.createdAt?.slice(0, 10),
      })),
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    XLSX.writeFile(workbook, "tour-booking-report.xlsx");
  };
  const handleRestFilter = () => {
    setStartDate("");
    setEndDate("");
    setSelectedTour("");
    setSelectedCustomer("");
  };
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        <div>
          <label className="text-xs">Tours</label>

          <select
            name=""
            id=""
            className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
            onChange={handleHotelChange}
          >
            <option value="">Select Tours</option>
            {Tours.map((item) => (
              <option key={item.id} value={item.id}>
                {item.tourName}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs">Customers</label>
          <select
            name=""
            id=""
            className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
            onChange={handleCustomerChange}
          >
            <option value="">Select Customer</option>
            {Customers.map((item) => (
              <option key={item.id} value={item.id}>
                {item.fullName}
              </option>
            ))}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-3 w-full">
          <div>
            <label className="text-xs">Start Date</label>
            <input
              type="date"
              className="w-full border px-4 py-2 rounded-lg focus:outline-none"
              value={StartDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div>
            <label className="text-xs">Start Date</label>
            <input
              type="date"
              className="w-full border px-4 py-2 rounded-lg focus:outline-none"
              value={EndDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="p-4 w-full overflow-x-auto space-y-3">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-lg font-semibold uppercase">
              Tour Booking Report
            </p>
          </div>
          <div className="flex justify-start items-center gap-2">
            <SendButton text={"Excel"} onClick={exportToExcel} />

            <CancelButton text={"Rest Filter"} onClick={handleRestFilter} />
          </div>
        </div>
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Invoice ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Trx ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tour Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Customer Name
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actual Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discounted Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Amount
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Start Date
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                End Date
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Booking Date
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {Data.length > 0 ? (
              <>
                {Data.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.invoiceId}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.transactionId}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-pretty">
                        {item.tourName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.fullName} <br />{" "}
                        <span className="text-xs">{item.phoneNumber}</span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.actualPrice || 0}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.discount > 0
                          ? (item.actualPrice || 0) -
                            ((item.actualPrice || 0) * (item.discount || 0)) /
                              100
                          : 0}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.totalAmount || 0}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`px-2 py-1 ${item.paymentStatus === "Paid" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"} rounded text-xs text-nowrap`}
                        >
                          {item.paymentStatus === "Paid" ? "Paid" : "Not Paid"}
                        </span>
                      </td>

                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item?.startDate.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item?.endDate.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item?.createdAt.slice(0, 10)}
                      </td>
                    </tr>
                  );
                })}

                <tr>
                  <td
                    colSpan={5}
                    className="px-4 py-3 text-right text-sm font-bold"
                  >
                    Total:
                  </td>
                  <td className="px-4 py-3 text-sm font-semibold">
                    {totalSummary.actualPrice}
                  </td>
                  <td className="px-4 py-3 text-sm font-semibold">
                    {totalSummary.discountedAmount}
                  </td>
                  <td className="px-4 py-3 text-sm font-semibold">
                    {totalSummary.totalAmount}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </>
            ) : (
              <tr className="hover:bg-gray-50">
                <td
                  colSpan={11}
                  className="px-4 py-3 text-center text-sm text-gray-700"
                >
                  No Data to show
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TourBookingReport;
